import { z } from 'zod';

export const getGroupItemsForQstGenericGroupsMaterialsSchema = z.array(
  z.object({
    groupItemId: z.string(),
    groupItemLevel: z.number(),
    groupItemName: z.string(),
    boid: z.string().optional(),
    materialId: z.string(),
    materialName: z.string(),
    materialSequence: z.number().optional(),
  })
);

export type GetGroupItemsForQstGenericGroupsMaterialsResponse = z.infer<
  typeof getGroupItemsForQstGenericGroupsMaterialsSchema
>;
